import { useState } from 'react';

/**
 * Hero background video. The source (bg_boomerang.webm) is pre-rendered
 * forward+reverse, so a plain native loop ping-pongs (boomerangs) smoothly with
 * no frame-by-frame seeking. bg7.png (the .bf-hero-bg background) shows as a
 * placeholder until the first video frame is decoded, then the video fades in.
 */
export function HeroBgVideo() {
  const [ready, setReady] = useState(false);
  return (
    <video
      ref={(v) => {
        if (v) v.muted = true;
      }}
      className={`bf-hero-video${ready ? ' is-ready' : ''}`}
      src="/bg_boomerang.webm"
      autoPlay
      loop
      muted
      playsInline
      onLoadedData={() => setReady(true)}
    />
  );
}
